import _ from 'lodash';
import moment from 'moment';

import { KitchenPrepWorksheetEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import * as types from './types';

const INITIAL_STATE = {
  kitchenPrepWorksheetItems: [],
  fetchKitchenPrepWorksheetError: null,
  fetchKitchenPrepWorksheetLoading: false,
  fetchWHKITListLoading: false,
  wHKITListData: [],
  fetchWHKITListLoadingError: null,
  fromDateMax: moment().add(1, 'month'),
  toDateMin: moment().subtract(1, 'month'),
  printLoading: false,
  printError: null,
  closeLoading: false,
  closeSuccess: null,
  closeError: null,
  printData: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.KITCHEN_PREP_WORKSHEET_LOADING:
      return { ...state, fetchKitchenPrepWorksheetLoading: action.payload };
    case types.KITCHEN_PREP_WORKSHEET_DATA:
      return {
        ...state,
        kitchenPrepWorksheetItems: action.payload.map(item => ({
          ...item,
          [KitchenPrepWorksheetEnum.DeliveryDate]: item[
            KitchenPrepWorksheetEnum.DeliveryDate
          ]
            ? moment(item[KitchenPrepWorksheetEnum.DeliveryDate]).format(
                DATE_FORMAT_FOR_UI
              )
            : '',
        })),
      };
    case types.KITCHEN_PREP_WORKSHEET_FETCHING_ERROR:
      return { ...state, fetchKitchenPrepWorksheetError: action.payload };

    case types.FETCH_WAREHOUSE_KITCHEN_LIST_LOADING:
      return { ...state, fetchWHKITListLoading: action.payload };

    case types.WAREHOUSE_KITCHEN_LIST_DATA:
      const kitchenData = _.filter(action.payload, [
        KitchenPrepWorksheetEnum.SiteMasterTypeId,
        3,
      ]);
      return { ...state, wHKITListData: kitchenData };

    case types.FETCH_WAREHOUSE_KITCHEN_LIST_LOADING_ERROR:
      return { ...state, fetchWHKITListLoadingError: action.payload };

    case types.SET_FROM_DATE_MAX:
      return { ...state, fromDateMax: action.payload };

    case types.SET_TO_DATE_MIN:
      return { ...state, toDateMin: action.payload };

    case types.CLEAR_KITCHEN_ERROR:
      return {
        ...state,
        fetchWHKITListLoadingError: null,
        fetchKitchenPrepWorksheetError: null,
        printError: null,
        closeError: null,
        closeSuccess: null,
      };

    case types.PRINT_KITCHEN_PREP_WORKSHEET_LOADING:
      return { ...state, printLoading: action.payload };

    case types.PRINT_KITCHEN_PREP_WORKSHEET_ERROR:
      return { ...state, printError: action.payload };

    case types.KITCHEN_PREP_WORKSHEET_CLOSE_LOADING:
      return { ...state, closeLoading: action.payload };

    case types.KITCHEN_PREP_WORKSHEET_CLOSE:
      return { ...state, closeSuccess: action.payload };

    case types.KITCHEN_PREP_WORKSHEET_CLOSE_ERROR:
      return { ...state, closeError: action.payload };
    case types.PRINT_KITCHEN_PREP_WORKSHEET_DATA:
      return { ...state, printData: action.payload };
    case types.CLEAR_PRINT_KITCHEN_PREP_WORKSHEET_DATA:
      return { ...state, printData: null };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/kitchenPrepWorksheet/reducer.js